function r(t) {
  var n = typeof t;
  if (t && "object" === n && !(t instanceof Date || t instanceof RegExp)) {
    for (var e = Array.isArray(t) ? [] : {}, o = Object.keys(t).sort(function (r, t) {
        return r > t ? 1 : -1;
      }), i = o.length; i--;) {
      var a = o[i];
      e[a] = r(t[a]);
    }
    return String(t.constructor) + JSON.stringify(e, o);
  }
  return n + String(t);
}
function t(t) {
  t = r(t);
  for (var n = 5381, e = 0; e < t.length;) n = 33 * n ^ t.charCodeAt(e++);
  return n;
}
export { t as hash, r as serialize };